import React, { Component } from 'react'
import { Redirect }from 'react-router-dom'
import { connect } from 'react-redux'

// Actions
import {
  logOut
} from '../../actions/user'

import {
  eraseCookie,
} from '../../utils/helpers'

class LogOut extends Component {

  componentWillMount() {
    this.props.logOutUser()
  }

  componentDidMount() {
    eraseCookie('ll_user_logged_in');
  }

  render() {
    if (!this.props.user.isLoggedIn) {
      return <Redirect to={{
        pathname: '/log-in'
      }}/>
    }

    return null
  }
}

const mapStateToProps =  state  => {
  return {
    user: state.user
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    logOutUser: () => dispatch(logOut()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogOut)


// WEBPACK FOOTER //
// ./src/screens/Sessions/LogOut.js